<template>
  <div ref="swiper" :class="['swiper', {'swiper-single': single}]">
    <div class="swiper-wrapper">
      <div @click="edit" class="swiper-slide" v-for="slide in items" :key="slide.name">{{ slide.header }}: {{ slide.content }}</div>
    </div>

    <div class="swiper-prev">
      <span v-html="icon" class="swiper__icon"></span>
    </div>
    <div class="swiper-next">
      <span v-html="icon" class="swiper__icon"></span>
    </div>
  </div>
</template>

<script>
import Swiper, {Navigation} from 'swiper';
import ArrowSvg from '!!raw-loader!../../../../../../../assets/images/builders/arrow.svg';
import 'swiper/swiper.min.css';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    swiper: Object,
    icon: ArrowSvg,
  }),
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      modules: [Navigation],
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
    });
  },
  computed: {
    single() {
      return this.items.length < 2;
    },
  },
  methods: {
    edit() {
      this.$emit('edit');
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/web/_variables.scss';

.swiper {
  width: 500px;
  position: relative;
  cursor: pointer;
  height: 60px;
  color: $white-color;
  &-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 18px;
  }
  &-prev,
  &-next {
    display: inline-flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    cursor: pointer;
  }
  &-prev {
    left: 0;
  }
  &-next {
    transform: translateY(-50%) rotate(180deg);
    right: 0;
  }
  &-button-disabled {
    opacity: 0.3;
    pointer-events: none;
  }
  &-single &-button-disabled {
    display: none;
  }
}
</style>
